import Component from "@glimmer/component"
import styles from "./create.module.css"

export default class CreateEditFootersEditComponent extends Component {
  readonly styles = styles
}
